import React from 'react'

export type PaletteOptions = 'light' | 'dark'

// context object
export const PaletteContext = React.createContext<null | PaletteOptions>(null)

// context provider props
export interface ConfigProviderProps {
  children: JSX.Element | JSX.Element[]
  palette: PaletteOptions
}

// context provider
const PaletteProvider = ({ children, palette }: ConfigProviderProps) => {
  return (
    <PaletteContext.Provider value={palette}>
      {children}
    </PaletteContext.Provider>
  )
}

export default PaletteProvider
